import { render, staticRenderFns } from "./RateRangePlate.vue?vue&type=template&id=72ca3e2c"
import script from "./RateRangePlate.vue?vue&type=script&lang=js"
export * from "./RateRangePlate.vue?vue&type=script&lang=js"
import style0 from "./RateRangePlate.vue?vue&type=style&index=0&id=72ca3e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports